var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiFair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.003 368C289.075 368 264.003 393.07 264.003 424S289.075 480 320.003 480S376.003 454.93 376.003 424S350.931 368 320.003 368ZM520.626 286.688C467.876 235.938 396.628 208 320.003 208S172.13 235.938 119.38 286.688C109.818 295.906 109.505 311.094 118.692 320.625C127.911 330.25 143.099 330.469 152.63 321.312C196.411 279.188 255.847 256 320.003 256S443.595 279.188 487.376 321.312C492.032 325.781 498.001 328 504.001 328C510.282 328 516.595 325.531 521.314 320.625C530.501 311.094 530.189 295.906 520.626 286.688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiFair);
export default __webpack_public_path__ + "static/media/wifi-fair.411b86deb55d43953d972fb900961e88.svg";
export { ForwardRef as ReactComponent };